/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MagnetTaskDocumentList } from '../../models/magnet-task-document-list';

export interface TaskGetMagnetTaskDocumentList$Params {

/**
 * GUID of the task magnet
 */
  magnetId: string;

/**
 * Requested document count. Value must be less than or equal to 255
 */
  count?: number;
}

export function taskGetMagnetTaskDocumentList(http: HttpClient, rootUrl: string, params: TaskGetMagnetTaskDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<MagnetTaskDocumentList>> {
  const rb = new RequestBuilder(rootUrl, taskGetMagnetTaskDocumentList.PATH, 'get');
  if (params) {
    rb.path('magnetId', params.magnetId, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MagnetTaskDocumentList>;
    })
  );
}

taskGetMagnetTaskDocumentList.PATH = '/task/magnet/{magnetId}/document/list';
